@if (vm$ | async; as vm) {
  <ng-container *transloco="let t; read: 'revisions.detail'">
    <div class="xs12col m6col">
      <div class="fieldsetWrapper margin-right-small margin-bottom-medium">
        <fieldset class="fieldsetContainer flexRow">
          <div class="titleAdd">
            <h2 class="xs12col padding-right-small">{{ t('revisionReport') }}</h2>
          </div>
          @if(vm.revision?.revisionReportDocumentId != null){
            <div class="fullWidth margin-top-medium">
              <a (click)="reportDeletionDialogOpen(vm.revision.revisionReportDocumentId)" [hidden]="!('Permissions.Revisions.RemoveAttachment' | permission)" class="deleteIconList mlm"><img src="../../../assets/icons/delete-icon.svg"></a>
              <a (click)="downloadAttachment(vm.revision.revisionReportDocumentId, vm.revision.revisionReportDocumentFileName)">{{vm.revision.revisionReportDocumentFileName || t('revisionReport')}}</a>
            </div>
          }
          @else {
          <button
            kendoButton
            class="addIcon small"
            [hidden]="!('Permissions.Revisions.GenerateDocument' | permission)"
            loadingIndication="/revisions/createRevisionReport"
            (click)="generateRevisionReport()">
            <span class="icon">
              <img src="../../../assets/icons/add-icon.svg">
            </span>
          </button>
        }
        @if (vm.generatingReport) {
          <div class="loading-overlay fullWidth margin-top-medium">
            <span>
              <span class="text">{{ t('loading') }}</span>
              <img src="../../../assets/icons/reload.svg" class="spinner">
            </span>
          </div>
        }
      </fieldset>
    </div>
  </div>
  <div class="fieldsetWrapper margin-right-small margin-bottom-medium">
    <fieldset class="fieldsetContainer flexRow">
      <div class="titleAdd">
        <h2 class="xs12col">{{ t('documents') }}</h2>
        <span  class="tooltipContainer">
          <span [attr.tooltip]="t('upload.revision.tooltipDocuments')" flow="right" class="tooltipContainer">
            <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
          </span>
        </span>
      </div>
      <kendo-upload
        kendoButton
        loadingIndication="/attachment/uploadAttachment"
        (upload)="uploadRevisionAttachment($event, revisionId)"
        [disabled]="revisionStatus?.isFinalStatus == true"
        [ngClass]="{ 'uploading': vm.isUploading }"
        [batch]="true"
        [restrictions]="revisionRestrictions"
        class="margin-bottom-medium margin-top-medium">
        <kendo-upload-messages
          [dropFilesHere]="t('upload.revision.dropZone')"
          [select]="vm.isUploading ? '&#x21bb;' : t('upload.revision.button')">
        </kendo-upload-messages>
      </kendo-upload>
      <div class="xs12col attachmentWrapper">
        @for (document of vm.documents; track document) {
          <div class="attachmentItem">
            <a (click)="documentDeletionDialogOpen(document.id)" [hidden]="!('Permissions.Revisions.RemoveAttachment' | permission) || revisionStatus?.isFinalStatus == true" class="deleteIconList"><img src="../../../assets/icons/delete-icon.svg"></a>
            <a (click)="downloadAttachment(document.id,document.fileName)">{{ document.fileName }}</a>
          </div>
        }
      </div>
    </fieldset>
    @if (documentDeletionDialogOpened) {
      <kendo-dialog
        title="{{t('confirmDeletion')}}"
        (close)="documentDeletionDialogClose('cancel')"
        [minWidth]="250"
        [width]="450">
        <p style="margin: 30px; text-align: center;">
          {{t('documentDeletionMessage')}}
        </p>
        <kendo-dialog-actions>
          <button kendoButton (click)="documentDeletionDialogClose('cancel')">{{ t('cancel') }}</button>
          <button kendoButton (click)="documentDeletionDialogClose('delete')" themeColor="primary">{{ t('delete') }}
          </button>
        </kendo-dialog-actions>
      </kendo-dialog>
    }
    @if (reportDeletionDialogOpened) {
      <kendo-dialog
        title="{{t('confirmDeletion')}}"
        (close)="reportDeletionDialogClose('cancel')"
        [minWidth]="250"
        [width]="450">
        <p style="margin: 30px; text-align: center;">
          {{t('reportDeletionMessage')}}
        </p>
        <kendo-dialog-actions>
          <button kendoButton (click)="reportDeletionDialogClose('cancel')">{{ t('cancel') }}</button>
          <button kendoButton (click)="reportDeletionDialogClose('delete')" themeColor="primary">{{ t('delete') }}
          </button>
        </kendo-dialog-actions>
      </kendo-dialog>
    }
  </div>
</ng-container>
}